import {
  MAP_METHODS_MODAL_TRACKING,
  MAP_METHODS_SELECTOR_TRACKING,
} from './constants/proof-income-landing.tracking.handlers.constants';

const mapMethodToTracking = (method: string): string =>
  MAP_METHODS_SELECTOR_TRACKING[method] ?? method;

const mapMethodToModalTracking = (method: string): string =>
  MAP_METHODS_MODAL_TRACKING[method] ?? method;

export { mapMethodToModalTracking, mapMethodToTracking };
